import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.css';

const Login = () => {
  const [gmail, setGmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorVisible, setErrorVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let users = [{
      name: "student",
      gmail: "student@eui.edu.eg",
      password: 123456
    }];
    
    localStorage.setItem("localUsers", JSON.stringify(users));
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    
    let localUsers = JSON.parse(localStorage.getItem("localUsers"));
    let isValid = false;

    for (let i = 0; i < localUsers.length; i++) {
      if (gmail == localUsers[i].gmail && password == localUsers[i].password) {
        isValid = true;
      }
    }

    if (isValid) {
      navigate('/');
    } else {
      setErrorVisible(true);
    }
  };

  return (
    <div className="login_page">
      <div className="login_container">
        <h1 className="login_title" id="login_title">EVENTRA ADMIN</h1>
        <p className="login_subtitle" id="login_subtitle">Enter your dashboard credentials</p>

        {errorVisible && (
          <div className="login_error" id="style">
            Your Credentials are Incorrect
          </div>
        )}

        <form className="login_form" onSubmit={handleLogin}>
          <div className="login_field">
            <label htmlFor="gmail">Gmail</label>
            <input 
              id="gmail" 
              onChange={(e) => setGmail(e.target.value)}
              required 
              type="email" 
              value={gmail}
            />
          </div>

          <div className="login_field">
            <label htmlFor="password">Password</label>
            <input 
              id="password" 
              onChange={(e) => setPassword(e.target.value)}
              required 
              type="password" 
              value={password}
            />
          </div>

          <button className="login_button" id="login_btn" type="submit">
            ACCESS DASHBOARD
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
